import { render, staticRenderFns } from "./ConnectedUserList.vue?vue&type=template&id=64a0e2b0&"
import script from "./ConnectedUserList.vue?vue&type=script&lang=js&"
export * from "./ConnectedUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports